module.exports = __webpack_public_path__ + "static/media/hh.ef10cb1c.jpg";